<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  variant: {
    type: String as PropType<'white' | 'black' | 'yellow'>,
    default: 'white',
  },
})
</script>

<template>
  <span
    variant="unstyled"
    :class="variant"
    class="block rounded-full px-2.5 py-1.5 text-xxs font-semibold"
  >
    <slot />
  </span>
</template>

<style scoped lang="scss">
.white {
  @apply border border-s-900 bg-white text-s-900;

  &:hover {
    @apply bg-s-100;
  }

  &:active {
    @apply bg-s-300;
  }
}

.black {
  @apply border border-white bg-s-900 text-white;

  &:hover {
    @apply bg-s-700;
  }

  &:active {
    @apply bg-s-600;
  }
}

.yellow {
  @apply border border-p-400 bg-p-400 text-s-900;

  &:hover {
    @apply bg-p-300;
  }

  &:active {
    @apply bg-p-200;
  }
}
</style>
